{
  "template": {
    "section": "Note template",
    "meta": {
      "preset": "From the {{preset}} preset, edited · {{count}} items",
      "presetPristine": "{{preset}} preset · {{count}} items",
      "custom": "Custom · {{count}} items"
    },
    "edit": "Edit template",
    "applyNote": "Applies to every {{subject}} session from the next one on. Notes already saved don't change.",
    "group": {
      "class": "Whole-class notes",
      "student": "Per student",
      "homework": "Homework",
      "emptyRow": "No items yet. This group is hidden in the note form."
    },
    "empty": {
      "body": "No template yet. The session-note form is a free-text box for now. Pick a template to write faster and more consistently: each item becomes its own field, and everyone notes the same things.",
      "hint": "You can still edit every item before saving, once you've picked one."
    },
    "preset": {
      "music": "Music",
      "art": "Art",
      "exam": "Exam prep",
      "custom": "Start from scratch",
      "customSub": "Start with three empty groups"
    },
    "editor": {
      "title": "Note template · {{subject}}",
      "desc": "Each item becomes a field in the session-note form. The hint shows as a placeholder — teachers don't have to fill every field.",
      "descPreset": "{{preset}} preset. Edit the item names and hints to fit your class, then save."
    },
    "item": {
      "namePh": "Item name",
      "hintPh": "Hint for the teacher (optional)",
      "add": "Add item",
      "remove": "Remove item",
      "drag": "Drag to reorder"
    },
    "count": "{{count}} items",
    "resetToPreset": "Reset to {{preset}}",
    "resetTitle": "Reset to the {{preset}} preset?",
    "resetBody": "Any items you edited will be replaced with the original set.",
    "resetConfirm": "Reset",
    "resetCancel": "Keep editing",
    "save": "Save template",
    "savedToast": "Saved the note template for {{subject}}",
    "rating": {
      "label": "Session rating",
      "desc": "The teacher picks one of five levels per student per session: Báo động, Cần chú ý, Khá, Tốt, Xuất sắc. Shown on the parent page with a monthly tally; the AI reads it when drafting the monthly review.",
      "on": "On",
      "off": "Off",
      "savedOn": "Session rating turned on",
      "savedOff": "Session rating turned off"
    }
  },
  "notes": {
    "entry": {
      "title": "Session notes",
      "empty": "Nothing yet. Jot a few lines right after class, for the whole class or per student.",
      "summaryClass": "Whole class",
      "summaryStudents": "{{count}} individual",
      "summaryHomework": "Shared homework",
      "edit": "Edit"
    },
    "header": {
      "meta": "{{subject}} · {{day}} · {{roster}} students, {{present}} present · Fill in whatever applies"
    },
    "templateHint": {
      "text": "This subject has no note template yet.",
      "cta": "Create a template"
    },
    "class": {
      "label": "Whole class",
      "comment": "Class comment",
      "commentPh": "What did the class cover today, what went well, anything to note…",
      "homework": "Shared homework",
      "copyDown": "Copy this down to each student",
      "copiedToast": "Copied to {{count}} students",
      "collapse": "Collapse",
      "expand": "Expand"
    },
    "homework": {
      "common": "Shared homework",
      "personal": "Individual homework",
      "personalHint": "Leave blank if only the shared homework applies"
    },
    "extra": {
      "add": "Note outside the template",
      "label": "Extra note"
    },
    "student": {
      "label": "Per student",
      "hint": "Tap a name to write",
      "hintCount": "{{count}} students have their own note",
      "comment": "Note for {{name}}",
      "commentPh": "Something specific to {{name}} today…",
      "homework": "Individual homework",
      "homeworkPh": "Leave blank if only the shared homework applies",
      "rating": "Session level",
      "ratingHint": "Optional. Tap again to clear.",
      "ratingClear": "Clear"
    },
    "openFor": "Note for {{name}}",
    "cancel": "Cancel",
    "save": "Save note",
    "savedToast": "Saved the note for {{date}}",
    "discardTitle": "Discard what you wrote?",
    "discardBody": "Unsaved content will be lost.",
    "discardConfirm": "Discard",
    "discardCancel": "Keep writing",
    "photos": {
      "add": "Add photos",
      "dropTitle": "Drop photos here or <1>choose photos</1>",
      "dropHint": "Several at once · up to {{max}} photos · JPG, PNG",
      "dismiss": "Stop adding photos",
      "remove": "Remove photo",
      "uploading": "Uploading photos",
      "more": "+{{n}}",
      "count": "{{n}} photos",
      "limitToast": "At most {{max}} photos per homework block",
      "failToast": "{{name}} could not be uploaded: {{reason}}",
      "reason": {
        "heic": "HEIC format, choose JPG or PNG",
        "notImage": "not an image",
        "tooLarge": "over {{max}} MB",
        "upload": "upload failed, try again"
      },
      "locked": "Homework photos come with the Pro plan"
    }
  },
  "review": {
    "title": "Review for {{month}}",
    "progress": "{{done}}/{{total}} written",
    "filter": {
      "todo": "To write",
      "all": "All",
      "drafts": "To approve"
    },
    "doneGroup": "Written",
    "aiDrafted": "AI draft, edited",
    "manual": "Written manually",
    "noteMetaNoNotes": "{{sessions}} sessions · no notes yet",
    "emptySelect": "Select a student from the list on the left to write a review.",
    "loadError": "Could not load the monthly review list. Try again later.",
    "noteMeta": "{{sessions}} sessions · {{notes}} notes",
    "panelMeta": "{{subject}} · {{month}} · {{sessions}} sessions: {{present}} present, {{excused}} excused, {{absent}} absent",
    "position": "Student {{index}}/{{total}}",
    "profileLink": "Student profile",
    "noNotesBox": "No session notes for {{name}} yet in {{month}}. Attended {{sessions}} sessions: {{present}} present, {{absent}} absent. You can write a review from memory, or skip this student.",
    "classPrefix": "Whole class:",
    "absentDay": "Absent.",
    "ai": {
      "button": "AI draft",
      "busy": "Writing…",
      "helperEnabled": "Summarized from {{count}} notes this month · 1 AI credit",
      "helperDisabled": "No session notes yet for AI to summarize. Add notes after each session and AI can draft a review next month.",
      "banner": "Draft summarized by AI from {{count}} notes in {{month}}. Read it over, adjust it to your own voice, then save.",
      "redo": "Redo draft",
      "clear": "Clear, write manually",
      "quota": "Out of AI credit this month. You can still write manually, or buy more credit.",
      "failedToast": "Couldn't generate a draft; the credit still counts against this attempt. Tap again to retry.",
      "replaceTitle": "Replace what you're writing with the AI draft?",
      "replaceConfirm": "Replace",
      "replaceCancel": "Keep"
    },
    "editorPh": "A few lines for {{name}}'s parents: what they learned this month, where they improved, what to work on…",
    "editorHint": "Parents will read this exactly as written, on the parent portal and on the {{nextMonth}} invoice. Avoid internal shorthand.",
    "credits": "{{count}} AI credits left",
    "save": "Save",
    "saveNext": "Save and go to next student",
    "skip": "Skip",
    "allDone": "Finished {{total}}/{{total}} students",
    "savedToast": "Saved {{name}}'s review for {{month}}",
    "entryButton": "Review for {{month}}",
    "attentionCard": "Review for {{month}} · {{subject}} · {{done}}/{{total}} written",
    "attentionCardMore": "Review for {{month}} · {{count}} more subjects, {{done}}/{{total}} written",
    "written": "Written",
    "notWritten": "Not written",
    "subtitle": "{{subject}} · {{count}} students · {{done}}/{{total}} written · Once written, it appears on the parent page and on the {{nextMonth}} tuition sheet",
    "subtitlePhone": "{{done}}/{{total}} written · shown on the parent page and the {{nextMonth}} sheet",
    "notesHeading": "Notes this month",
    "writing": "writing",
    "startFirst": "Start with the first student",
    "monthPickerLabel": "Pick the review month",
    "draftGroup": "Drafts awaiting approval",
    "draftMeta": "AI draft, not approved",
    "draftTag": "Draft awaiting approval",
    "draftNotice": "AI draft, not visible to parents yet. Read it, fix the voice, then press Approve.",
    "saveDraft": "Save draft",
    "approve": "Approve",
    "approveNext": "Approve and next student",
    "approveNextShort": "Approve and next",
    "draftSavedToast": "Draft saved for {{name}}, parents cannot see it yet",
    "publishAll": "Approve all {{count}} drafts",
    "publishAllTitle": "Approve all {{count}} drafts?",
    "publishAllBody": "{{count}} reviews will appear on the parent page and the {{nextMonth}} invoice, exactly as saved. Open any draft you have not read first.",
    "publishAllConfirm": "Approve all",
    "publishAllCancel": "Let me read each one",
    "publishAllToast": "{{count}} reviews approved",
    "batch": {
      "button": "AI drafts for {{count}} students",
      "confirmTitle": "Draft with AI for {{count}} students?",
      "confirmBody": "Uses {{count}} AI credits, {{left}} left. Drafts are not shown to parents; approve them one by one or all at once later. Keep this page open while it runs.",
      "confirmBodyShort": "Needs {{count}} AI credits but only {{left}} are left: it will draft until credits run out, then stop. Drafts are not shown to parents. Keep this page open while it runs.",
      "confirmBodyNoMeter": "One AI credit per student, {{count}} in total. Drafts are not shown to parents; approve them one by one or all at once later. Keep this page open while it runs.",
      "confirm": "Draft",
      "cancel": "Cancel",
      "progress": "Drafting {{done}}/{{total}}",
      "stop": "Stop",
      "doneToast": "{{count}} drafts ready for your approval",
      "partialToast": "{{done}} drafts written, {{failed}} failed. Run again to continue with the rest.",
      "quotaToast": "Out of AI credits after {{done}} drafts. Write the rest yourself or buy more credits.",
      "stopping": "Stopping, finishing the drafts in progress…",
      "skippedToast": "Nothing more to draft: {{count}} students already have a review or have no written notes."
    }
  },
  "progress": {
    "tab": "Learning progress",
    "profileTab": "Profile",
    "monthMeta": "{{sessions}} sessions · {{present}} present · {{excused}} excused · {{absent}} absent · {{notes}} notes",
    "writeReview": "Write the {{month}} review",
    "editReview": "Edit",
    "reviewHeading": "Monthly review · {{subject}}",
    "reviewMeta": "{{teacher}} · {{date}}",
    "classChip": "Whole class",
    "loadMore": "Show month {{month}} and earlier",
    "asideReviews": "Monthly reviews",
    "asideWrite": "Write",
    "emptyTitle": "No notes yet for {{name}}",
    "emptyBody": "After each session, open the session and tap \"Session notes\". Notes are automatically grouped here by month, so another teacher can read them and understand the student right away, and by month's end you have material ready for a review.",
    "emptyCta": "Open today's session",
    "monthTitle": "{{month}}",
    "asideShowAll": "Show all",
    "legacyFree": "Written before the subject had a template",
    "homeworkLabel": "Homework"
  },
  "link": {
    "title": "Parent portal",
    "open": "Currently open",
    "descCreated": "Parents open it via the link, no account needed. They see attendance, session notes and the monthly review for {{name}}.",
    "descNew": "A private link for {{name}}'s parents: monthly attendance, session notes and the monthly review. No account needed, only whoever has the link can view it.",
    "create": "Create parent portal link",
    "copy": "Copy link",
    "copied": "Copied the parent portal link for {{name}}",
    "copyFailed": "Couldn't copy the link, please copy it by hand.",
    "hint": "Paste it into a Zalo message to the parents, once is enough. Tell them to tap \"Cài app\" so it opens in one tap next time.",
    "openPage": "Open parent page",
    "regenerate": "Create new link",
    "regenTitle": "Create a new parent portal link?",
    "regenBody": "The old link stops working immediately. Parents still holding the old link will see a page that no longer exists, so you'll need to send them the new one. Notes and reviews are not affected.",
    "regenConfirm": "Create new link, cancel the old one",
    "regenCancel": "Keep the current link",
    "proTitle": "Parent portal is a Pro feature",
    "proBody": "The notes and reviews you're writing are still saved in full. Upgrade to Pro to send parents a link to view attendance, notes and the monthly review for {{name}}, no account needed.",
    "proCta": "See Pro plans",
    "sample": "View sample page",
    "bulkCreate": "Create parent portal links",
    "bulkConfirmTitle": "Create parent portal links?",
    "bulkConfirmBody": "This creates a link for {{missing}} students without one; {{existing}} students already have one and are left unchanged.",
    "bulkAllLinked": "Every active student already has a parent link.",
    "bulkConfirmAction": "Create links",
    "bulkConfirmCancel": "Cancel",
    "bulkCreatedToast": "Created links for {{count}} students",
    "bulkCreatedToast_one": "Created a link for 1 student",
    "bulkPrompt": "{{count}} students have no parent portal link",
    "bulkPromptAction": "Create now",
    "bulkButton": "Parent link",
    "hint2": "The ⋯ menu has \"New link\" (the old one stops working immediately)."
  },
  "switcher": {
    "prev": "Previous month",
    "next": "Next month"
  },
  "monthlyReviewsIndex": {
    "title": "Monthly reviews",
    "totalLine": "{{done}}/{{total}} students reviewed",
    "writeMore": "Continue",
    "viewDone": "View",
    "doneLabel": "Written",
    "noNotes": "{{count}} students have no session notes",
    "emptyTitle": "No subject needs a review for {{month}} yet",
    "emptyBody": "Once a session is scheduled this month, its subject appears here to write a review.",
    "loadError": "Could not load the monthly-review list. Try again later.",
    "drafts": "{{count}} drafts awaiting approval"
  },
  "lightbox": {
    "download": "Download",
    "close": "Close",
    "homework": "Homework",
    "common": "Class homework",
    "personal": "For {{name}}",
    "counter": "{{i}} / {{n}}"
  }
}
